// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BillingInvoices — downloadable invoices + receipts on the per-agent billing
   page. Rendered inside .bbp-page, so it mirrors the MessageCredits section
   shell (DM Sans, brand purple #5616ea, soft cards) and the same hardcoded
   tokens, so the block also looks right outside .bbp-page. */

.bbi-invoices {
  font-family: "DM Sans", sans-serif;
  color: #18181b;
  margin-top: 36px;
  padding-top: 28px;
  border-top: 1px solid #e2e2e6;
}

.bbi-head { margin-bottom: 18px; }
.bbi-title {
  display: flex;
  align-items: center;
  gap: 9px;
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #18181b;
}
.bbi-title svg { color: #5616ea; font-size: 15px; }
.bbi-sub {
  margin: 6px 0 0;
  font-size: 13.5px;
  line-height: 1.5;
  color: #63636b;
  max-width: 620px;
}

.bbi-error {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding: 10px 13px;
  border-radius: 10px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #b91c1c;
  font-size: 13.5px;
}

.bbi-loading {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 14px 0;
  font-size: 13.5px;
  color: #63636b;
}
.bbi-loading svg { color: #5616ea; }

/* Narrow viewports scroll the table itself, never the page. */
.bbi-table-wrap {
  overflow-x: auto;
  border: 1px solid #e6e6ea;
  border-radius: 12px;
  background: #fff;
}

.bbi-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13.5px;
  min-width: 460px;
}

.bbi-table thead th {
  text-align: left;
  padding: 11px 16px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #7a7a85;
  background: #fafafc;
  border-bottom: 1px solid #e6e6ea;
  white-space: nowrap;
}

.bbi-table tbody td {
  padding: 13px 16px;
  border-bottom: 1px solid #f0f0f3;
  vertical-align: middle;
}
.bbi-table tbody tr:last-child td { border-bottom: none; }
.bbi-table tbody tr:hover { background: #fbfaff; }

.bbi-date { color: #63636b; white-space: nowrap; }
.bbi-desc { color: #18181b; font-weight: 500; }
.bbi-num { text-align: right; white-space: nowrap; font-variant-numeric: tabular-nums; }
.bbi-table tbody .bbi-num { color: #18181b; font-weight: 600; }
.bbi-act { text-align: right; white-space: nowrap; width: 1%; }

.bbi-link {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 6px 12px;
  border-radius: 8px;
  border: 1px solid #d9ccff;
  background: #f4f0ff;
  color: #4a2bb5;
  font-size: 12.5px;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.bbi-link:hover { background: #ece5ff; border-color: #c4b0ff; }
.bbi-link svg { font-size: 11px; }

/* Older credit purchases have only a hosted receipt page, no PDF — same shape,
   quieter styling so the downloadable rows read as the primary action. */
.bbi-link-soft {
  border-color: #e2e2e6;
  background: #fafafc;
  color: #4a4a55;
}
.bbi-link-soft:hover { background: #f2f2f5; border-color: #d4d4da; }

.bbi-none { font-size: 12.5px; color: #9a9aa3; }

.bbi-all {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-top: 14px;
  padding: 0;
  border: none;
  background: none;
  color: #5616ea;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.bbi-all:hover { text-decoration: underline; }
.bbi-all svg { font-size: 11px; }

@media (max-width: 640px) {
  .bbi-table thead th,
  .bbi-table tbody td { padding: 11px 12px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/BillingInvoices.css"],"names":[],"mappings":"AAAA;;;6DAG6D;;AAE7D;EACE,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,YAAY,mBAAmB,EAAE;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA,iBAAiB,cAAc,EAAE,eAAe,EAAE;AAClD;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA,mBAAmB,cAAc,EAAE;;AAEnC,8DAA8D;AAC9D;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;AACxB;AACA,oCAAoC,mBAAmB,EAAE;AACzD,4BAA4B,mBAAmB,EAAE;;AAEjD,YAAY,cAAc,EAAE,mBAAmB,EAAE;AACjD,YAAY,cAAc,EAAE,gBAAgB,EAAE;AAC9C,WAAW,iBAAiB,EAAE,mBAAmB,EAAE,kCAAkC,EAAE;AACvF,4BAA4B,cAAc,EAAE,gBAAgB,EAAE;AAC9D,WAAW,iBAAiB,EAAE,mBAAmB,EAAE,SAAS,EAAE;;AAE9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,0DAA0D;AAC5D;AACA,kBAAkB,mBAAmB,EAAE,qBAAqB,EAAE;AAC9D,gBAAgB,eAAe,EAAE;;AAEjC;yEACyE;AACzE;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA,uBAAuB,mBAAmB,EAAE,qBAAqB,EAAE;;AAEnE,YAAY,iBAAiB,EAAE,cAAc,EAAE;;AAE/C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,iBAAiB,0BAA0B,EAAE;AAC7C,eAAe,eAAe,EAAE;;AAEhC;EACE;wBACsB,kBAAkB,EAAE;AAC5C","sourcesContent":["/* BillingInvoices — downloadable invoices + receipts on the per-agent billing\r\n   page. Rendered inside .bbp-page, so it mirrors the MessageCredits section\r\n   shell (DM Sans, brand purple #5616ea, soft cards) and the same hardcoded\r\n   tokens, so the block also looks right outside .bbp-page. */\r\n\r\n.bbi-invoices {\r\n  font-family: \"DM Sans\", sans-serif;\r\n  color: #18181b;\r\n  margin-top: 36px;\r\n  padding-top: 28px;\r\n  border-top: 1px solid #e2e2e6;\r\n}\r\n\r\n.bbi-head { margin-bottom: 18px; }\r\n.bbi-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 9px;\r\n  margin: 0;\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n  color: #18181b;\r\n}\r\n.bbi-title svg { color: #5616ea; font-size: 15px; }\r\n.bbi-sub {\r\n  margin: 6px 0 0;\r\n  font-size: 13.5px;\r\n  line-height: 1.5;\r\n  color: #63636b;\r\n  max-width: 620px;\r\n}\r\n\r\n.bbi-error {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-bottom: 16px;\r\n  padding: 10px 13px;\r\n  border-radius: 10px;\r\n  background: #fef2f2;\r\n  border: 1px solid #fecaca;\r\n  color: #b91c1c;\r\n  font-size: 13.5px;\r\n}\r\n\r\n.bbi-loading {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 9px;\r\n  padding: 14px 0;\r\n  font-size: 13.5px;\r\n  color: #63636b;\r\n}\r\n.bbi-loading svg { color: #5616ea; }\r\n\r\n/* Narrow viewports scroll the table itself, never the page. */\r\n.bbi-table-wrap {\r\n  overflow-x: auto;\r\n  border: 1px solid #e6e6ea;\r\n  border-radius: 12px;\r\n  background: #fff;\r\n}\r\n\r\n.bbi-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 13.5px;\r\n  min-width: 460px;\r\n}\r\n\r\n.bbi-table thead th {\r\n  text-align: left;\r\n  padding: 11px 16px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  letter-spacing: 0.02em;\r\n  text-transform: uppercase;\r\n  color: #7a7a85;\r\n  background: #fafafc;\r\n  border-bottom: 1px solid #e6e6ea;\r\n  white-space: nowrap;\r\n}\r\n\r\n.bbi-table tbody td {\r\n  padding: 13px 16px;\r\n  border-bottom: 1px solid #f0f0f3;\r\n  vertical-align: middle;\r\n}\r\n.bbi-table tbody tr:last-child td { border-bottom: none; }\r\n.bbi-table tbody tr:hover { background: #fbfaff; }\r\n\r\n.bbi-date { color: #63636b; white-space: nowrap; }\r\n.bbi-desc { color: #18181b; font-weight: 500; }\r\n.bbi-num { text-align: right; white-space: nowrap; font-variant-numeric: tabular-nums; }\r\n.bbi-table tbody .bbi-num { color: #18181b; font-weight: 600; }\r\n.bbi-act { text-align: right; white-space: nowrap; width: 1%; }\r\n\r\n.bbi-link {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  padding: 6px 12px;\r\n  border-radius: 8px;\r\n  border: 1px solid #d9ccff;\r\n  background: #f4f0ff;\r\n  color: #4a2bb5;\r\n  font-size: 12.5px;\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n  transition: background 0.15s ease, border-color 0.15s ease;\r\n}\r\n.bbi-link:hover { background: #ece5ff; border-color: #c4b0ff; }\r\n.bbi-link svg { font-size: 11px; }\r\n\r\n/* Older credit purchases have only a hosted receipt page, no PDF — same shape,\r\n   quieter styling so the downloadable rows read as the primary action. */\r\n.bbi-link-soft {\r\n  border-color: #e2e2e6;\r\n  background: #fafafc;\r\n  color: #4a4a55;\r\n}\r\n.bbi-link-soft:hover { background: #f2f2f5; border-color: #d4d4da; }\r\n\r\n.bbi-none { font-size: 12.5px; color: #9a9aa3; }\r\n\r\n.bbi-all {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  margin-top: 14px;\r\n  padding: 0;\r\n  border: none;\r\n  background: none;\r\n  color: #5616ea;\r\n  font-family: inherit;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n.bbi-all:hover { text-decoration: underline; }\r\n.bbi-all svg { font-size: 11px; }\r\n\r\n@media (max-width: 640px) {\r\n  .bbi-table thead th,\r\n  .bbi-table tbody td { padding: 11px 12px; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
